export { default } from './SubscriptionForm';
export type { IPrismicSubscriptionFormPrimary } from './types';
